import { render } from "./NavSidebarGroup.vue?vue&type=template&id=b16b918e&scoped=true"
import script from "./NavSidebarGroup.vue?vue&type=script&lang=js"
export * from "./NavSidebarGroup.vue?vue&type=script&lang=js"

import "./NavSidebarGroup.vue?vue&type=style&index=0&id=b16b918e&lang=scss&scoped=true"
import "./NavSidebarGroup.vue?vue&type=style&index=1&id=b16b918e&lang=scss"
script.render = render
script.__scopeId = "data-v-b16b918e"

export default script